// @flow

import React from 'react';

type Props = {
  slug: string,
  viewEvent?: string,
  clickEvent?: string,
  classes?: string
};

const Banner = ({ slug, viewEvent, clickEvent, classes }: Props) => (
  <div className={`company-img js-company-react-img ${classes || ''}`}
    data-slug={slug}
    data-view-event={viewEvent}
    data-click-event={clickEvent}
  > </div>
);

Banner.defaultProps = {
  viewEvent: '',
  clickEvent: '',
  classes: ''
};

export default Banner;
